export const common = {
  // Navigation
  'nav.features': 'Функции',
  'nav.howItWorks': 'Как это работает',
  'nav.pricing': 'Цены',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'О нас',
  'nav.getStarted': 'Начать',

  // Hero Section
  'hero.badge': 'ИИ для принятия решений о бизнес-нишах',
  'hero.title1': 'Идеи дешевы.',
  'hero.title2': 'Плохие решения — нет.',
  'hero.subtitle': 'ИИ, который оценивает вашу бизнес-нишу',
  'hero.subtitleLine2': 'прежде чем вы инвестируете.',
  'hero.cta': 'Проверить идею',
  'hero.ctaSecondary': 'Как это работает',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Кредитов за запрос',
  'hero.stat2Value': 'От 7',
  'hero.stat2Label': 'Уровней оценки',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Честно и конфиденциально',

  // Features Section
  'features.title1': 'Мощные функции для',
  'features.title2': 'современных',
  'features.title3': 'компаний',
  'features.honestVerdict.title': 'Честный вердикт, а не хайп-оценка',
  'features.honestVerdict.description': 'Чёткие вердикты хорошо/средне/слабо на основе реальных рыночных данных и исследования конкурентов. Никаких оценок 9/10, чтобы польстить каждой идее.',
  'features.fullJourney.title': 'От проверки идеи до Builder Report',
  'features.fullJourney.description': 'Проверьте в чате, углубитесь в анализ рынка, экспортируйте Builder Report на 25–75 страниц с персонами, финансами, go-to-market и питч-деком.',
  'features.multilingual.title': '21 язык, локальные рыночные данные',
  'features.multilingual.description': 'От швейцарского МСП до соло-основателя в Сан-Паулу — ИИ отвечает на вашем языке с источниками из вашего рынка.',

  // How It Works
  'howItWorks.title': 'Как это работает',
  'howItWorks.subtitle': 'Четыре шага к ясности о вашей бизнес-нише.',
  'howItWorks.step1Title': 'Выберите план',
  'howItWorks.step1Desc': 'Starter, Pro или Builder – в зависимости от глубины вашей проверки.',
  'howItWorks.step2Title': 'Спросите ИИ',
  'howItWorks.step2Desc': 'Задайте свои вопросы о нише. Каждый запрос стоит 30 кредитов.',
  'howItWorks.step3Title': 'Получите честный вердикт',
  'howItWorks.step3Desc': 'ИИ оценивает: Хорошо, Средне или Плохо. Без приукрашивания.',
  'howItWorks.step4Title': 'Примите решение',
  'howItWorks.step4Desc': 'Теперь вы знаете, стоит ли продолжать.',

  // Pricing
  'pricing.title': 'Цены',
  'pricing.subtitle': 'Выберите план, соответствующий глубине вашей проверки.',
  'pricing.yearlyDiscount': 'Годовая подписка:',
  'pricing.yearlyDiscountValue': '-20% скидка',
  'pricing.perMonth': 'в месяц',
  'pricing.selectPlan': 'Выбрать план',
  'pricing.mostPopular': 'Самый популярный',
  'pricing.footer': 'Все цены в CHF. Кредиты списываются только за успешные ответы ИИ.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Для первоначальных тестов реальности.',
  'pricing.starter.credits': '2 500 кредитов',
  'pricing.starter.feature1': 'Генерация идеи ниши',
  'pricing.starter.feature2': 'Уточнение ниши',
  'pricing.starter.feature3': 'Проверка рыночной реальности',
  'pricing.starter.feature4': 'Оценка конкуренции',
  'pricing.starter.feature5': 'Оценка времени',
  'pricing.starter.feature6': 'Честный вердикт',
  'pricing.starter.feature7': 'Приватные сессии',
  'pricing.starter.feature8': 'История и экспорт',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Для более глубокой проверки.',
  'pricing.pro.credits': '5 000 кредитов',
  'pricing.pro.feature1': 'Все функции Starter',
  'pricing.pro.feature2': 'Больше кредитов для интенсивной проверки',
  'pricing.pro.feature3': 'Предложения по улучшению',
  'pricing.pro.feature4': 'Альтернативные ниши',
  'pricing.pro.feature5': 'Детальный анализ рынка',
  'pricing.pro.feature6': 'Приоритетная поддержка',
  'pricing.pro.feature7': 'Расширенные фильтры',
  'pricing.pro.feature8': 'Избранные сессии',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Идея → Бриф для разработчиков.',
  'pricing.builder.credits': 'Неограниченные кредиты',
  'pricing.builder.feature1': 'Все функции Pro',
  'pricing.builder.feature2': 'Неограниченные запросы к ИИ',
  'pricing.builder.feature3': 'Режим Builder: Бриф для разработчиков',
  'pricing.builder.feature4': 'Структурированный обзор проекта',
  'pricing.builder.feature5': 'Пользовательские потоки и основные функции',
  'pricing.builder.feature6': 'Технические заметки',
  'pricing.builder.feature7': 'Определение не-целей',
  'pricing.builder.feature8': 'Ограничение справедливого использования',
  'pricing.builder.limitNote': 'Лимит справедливого использования',
  'pricing.monthlyReset': 'Ежемесячный сброс',

  // Modal
  'pricing.modal.selected': 'выбран',
  'pricing.modal.comingSoon': 'Регистрация и обработка платежей скоро будут доступны.',
  'pricing.modal.patience': 'Мы работаем над тем, чтобы предоставить вам безопасный и бесшовный опыт. Пожалуйста, будьте терпеливы.',
  'pricing.modal.understood': 'Понятно',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Ответы честно и критично.',
  'faq.q1': 'Что конкретно делает IdeaOracle.ai?',
  'faq.a1': 'IdeaOracle.ai оценивает бизнес-идеи и ниши на рыночную логику, реальный спрос, конкуренцию, дифференциацию и осуществимость.\nЕсли есть основа, мы показываем, как её можно стратегически усилить.\nЕсли нет, мы об этом говорим.',
  'faq.q2': 'Вы также генерируете идеи?',
  'faq.a2': 'Да.\nНо не вслепую.\nМы разрабатываем подходы на основе рыночной логики – не мотивации или трендового хайпа.',
  'faq.q3': 'Вы оптимизируете бизнес-модели?',
  'faq.a3': 'Да – если есть потенциал.\nМы не полируем иллюзии.\nМы делаем жизнеспособные концепции более устойчивыми.',
  'faq.q4': 'Чем вы отличаетесь от других ИИ-инструментов?',
  'faq.a4': 'Другие инструменты дают вдохновение.\nМы даём оценку.\nФокус на реализме, а не на энтузиазме.',
  'faq.q5': 'Это гарантия успеха?',
  'faq.a5': 'Нет.\nМы сокращаем ошибочные решения – мы не устраняем риск.',
  'faq.q6': 'Для кого предназначен IdeaOracle.ai?',
  'faq.a6': 'Основатели перед запуском\nПредприниматели перед расширением\nSide-билдеры перед вложением времени\nИнвесторы перед проверкой\n\nКоротко: Для людей, которые хотят ясности до капитала.',
  'faq.q7': 'А если я ищу только подтверждение?',
  'faq.a7': 'Тогда IdeaOracle.ai – не тот инструмент.',
  'faq.q8': 'Насколько честен анализ?',
  'faq.a8': 'Настолько честен, насколько позволяют данные и рыночная механика.\nНикакой эйфории. Никакого снисхождения.',
  'faq.q9': 'Вы заменяете маркетинговые исследования?',
  'faq.a9': 'Нет.\nМы – стратегическая предварительная оценка, а не полное исследование рынка.',
  'faq.q10': 'Почему так бескомпромиссно?',
  'faq.a10': 'Потому что провал стоит дорого.\nЧестность – нет.',

  // Footer
  'footer.description': 'Эта платформа не помогает вам чувствовать себя хорошо – но принимать правильные решения.',
  'footer.product': 'Продукт',
  'footer.aiAssistant': 'ИИ-ассистент',
  'footer.howItWorks': 'Как это работает',
  'footer.pricing': 'Цены',
  'footer.faq': 'FAQ',
  'footer.legal': 'Юридическое',
  'footer.privacy': 'Конфиденциальность',
  'footer.terms': 'Условия',
  'footer.imprint': 'Выходные данные',
  'footer.support': 'Поддержка',
  'footer.contact': 'Контакт',
  'footer.documentation': 'Документация',
  'footer.copyright': '© 2025 IdeaOracle.ai. Все права защищены.',

  // AI Assistant
  'aiAssistant.title': 'ИИ-ассистент по нишам',
  'aiAssistant.subtitle': 'Вопросы о нишах',
  'aiAssistant.welcomeMessage': 'Привет! Опишите свою идею или спросите меня о нише. Я дам вам четкую и честную оценку.',
  'aiAssistant.demoResponse': 'Это демо. Чтобы получить реальные оценки ИИ, зарегистрируйтесь и выберите план.',
  'aiAssistant.placeholder': 'Опишите свою идею...',

  // Header & Sidebar
  'dashboard.header.title': 'Панель управления',
  'dashboard.sidebar.overview': 'Обзор',
  'dashboard.sidebar.newAnalysis': 'ИИ-ассистент',
  'dashboard.sidebar.history': 'История',
  'dashboard.sidebar.credits': 'Кредиты',
  'dashboard.sidebar.settings': 'Настройки',

  // Dashboard Overview
  'dashboard.overview.welcome': 'С возвращением, {{name}}',
  'dashboard.overview.subtitle': 'Вот краткий обзор вашей активности',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Осталось кредитов',
  'dashboard.stats.totalAnalyses': 'Всего анализов',
  'dashboard.stats.goodRatings': 'Положительные оценки',
  'dashboard.stats.nextReset': 'Следующий сброс через',
  'dashboard.stats.days': 'дней',

  // Quick Actions
  'dashboard.quickActions.title': 'Быстрые действия',
  'dashboard.quickActions.checkNewIdea': 'Проверить идею',
  'dashboard.quickActions.checkNewIdeaDesc': 'Проанализировать существующую бизнес-идею',
  'dashboard.quickActions.generateIdea': 'Сгенерировать идею',
  'dashboard.quickActions.generateIdeaDesc': 'Найти новую прибыльную нишу',
  'dashboard.quickActions.builderBriefing': 'Бриф Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Превратить идею в готовый для разработчиков бриф',
  'dashboard.quickActions.premiumOnly': 'Только Builder',

  // Chat Header
  'chat.title': 'ИИ-ассистент по нишам',
  'chat.subtitle': 'Задавайте вопросы о нишах. Я оцениваю критично и честно.',
  'chat.creditsLabel': 'Кредиты',

  // Chat Welcome
  'chat.welcomeTitle': 'Добро пожаловать в ИИ-ассистент по нишам',
  'chat.welcomeDesc': 'Опишите свою идею или спросите о нише. Я оценю честно: Хорошо, Средне или Плохо.',
  'chat.aiWelcome': 'Привет! Опишите свою идею или спросите меня о нише. Я дам вам четкую и честную оценку.',

  // Chat Suggestions
  'chat.suggestion1': 'Найдите мне прибыльную нишу.',
  'chat.suggestion2': 'У меня есть идея – оцените её честно.',
  'chat.suggestion3': 'Какие ниши имеют потенциал сейчас?',
  'chat.suggestion4': 'Уточните эту нишу и сделайте её более конкретной.',

  // Chat Actions
  'chat.newConversation': 'Новый разговор',
  'chat.today': 'Сегодня',
  'chat.yesterday': 'Вчера',
  'chat.thisWeek': 'На этой неделе',
  'chat.thisMonth': 'В этом месяце',
  'chat.older': 'Старше',
  'chat.messages': 'сообщений',
  'chat.renameConversation': 'Переименовать',
  'chat.deleteConversation': 'Удалить',
  'chat.cancel': 'Отмена',
  'chat.rename': 'Переименовать',
  'chat.delete': 'Удалить',
  'chat.favorite': 'Добавить в избранное',
  'chat.unfavorite': 'Удалить из избранного',
  'chat.searchSessions': 'Поиск разговоров...',
  'chat.noResults': 'Результатов не найдено',
  'chat.noSessions': 'Пока нет разговоров',
  'chat.enterNewName': 'Введите новое имя...',
  'chat.deleteConfirmMessage': 'Вы уверены, что хотите удалить этот разговор? Это действие нельзя отменить.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Введите свой вопрос… (стоит 30 кредитов)',
  'chat.send': 'Отправить',
  'chat.voice': 'Говорить',
  'chat.listeningPlaceholder': 'Я слушаю... Говорите сейчас.',
  'chat.stopListening': 'Остановить запись',
  'chat.recording': 'Запись...',
  'chat.speechNotSupported': 'Распознавание речи не поддерживается вашим браузером.',
  'chat.microphonePermissionDenied': 'Доступ к микрофону запрещен. Пожалуйста, разрешите доступ в настройках браузера.',
  'chat.errorNotEnoughCredits': 'Недостаточно кредитов. Пожалуйста, обновите свой план или дождитесь следующего сброса.',
  'chat.errorAiFailed': 'Ответ ИИ не удался. Кредиты не были списаны.',
  'chat.errorRateLimit': 'Слишком много запросов. Пожалуйста, подождите немного.',

  // Ratings
  'rating.good': 'Хорошо',
  'rating.medium': 'Средне',
  'rating.bad': 'Плохо',

  // Auth Page
  'auth.branding.headline1': 'Не каждая идея хороша.',
  'auth.branding.headline2': 'Мы скажем честно.',
  'auth.branding.subtitle': 'ИИ для принятия решений о бизнес-нишах. Ясно. Критично. Без приукрашивания.',
  'auth.benefits.privacy.title': '100% Конфиденциально',
  'auth.benefits.privacy.desc': 'Ваши идеи остаются полностью конфиденциальными и защищенными.',
  'auth.benefits.honest.title': 'Честный ИИ',
  'auth.benefits.honest.desc': 'Без приукрашивания – только четкая, критическая обратная связь.',
  'auth.benefits.fast.title': 'Быстрые Результаты',
  'auth.benefits.fast.desc': 'Получите ясность о вашей нише за минуты.',
  'auth.trust.users': 'Активных Пользователей',
  'auth.trust.ideas': 'Проанализированных Идей',
  'auth.trust.rating': 'Рейтинг',
  'auth.login.title': 'Вход',
  'auth.login.headline': 'С возвращением',
  'auth.login.subtitle': 'Войдите, чтобы продолжить.',
  'auth.login.forgotPassword': 'Забыли пароль?',
  'auth.login.submit': 'Войти',
  'auth.login.noAccount': 'Нет аккаунта?',
  'auth.login.signUp': 'Зарегистрироваться',
  'auth.register.title': 'Регистрация',
  'auth.register.headline': 'Создайте аккаунт',
  'auth.register.subtitle': 'Начните анализировать свои бизнес-идеи сегодня.',
  'auth.register.submit': 'Создать Аккаунт',
  'auth.register.hasAccount': 'Уже есть аккаунт?',
  'auth.register.signIn': 'Войти',
  'auth.fields.name': 'Полное Имя',
  'auth.fields.email': 'Email Адрес',
  'auth.fields.password': 'Пароль',
  'auth.fields.confirmPassword': 'Подтвердите Пароль',
  'auth.fields.selectPlan': 'Выберите план',
  'auth.placeholders.name': 'Введите ваше имя',
  'auth.placeholders.email': 'Введите ваш email',
  'auth.placeholders.password': 'Введите ваш пароль',
  'auth.placeholders.confirmPassword': 'Подтвердите ваш пароль',
  'auth.terms.accept': 'Я принимаю',
  'auth.terms.terms': 'Условия использования',
  'auth.privacy.accept': 'Я принимаю',
  'auth.privacy.policy': 'Политику конфиденциальности',
  'auth.errors.nameRequired': 'Имя обязательно',
  'auth.errors.emailRequired': 'Email обязателен',
  'auth.errors.emailInvalid': 'Введите корректный email',
  'auth.errors.passwordRequired': 'Пароль обязателен',
  'auth.errors.passwordLength': 'Пароль должен содержать минимум 8 символов',
  'auth.errors.passwordMismatch': 'Пароли не совпадают',
  'auth.loading': 'Пожалуйста, подождите...',
  'auth.or': 'или продолжить с',
  'auth.social.google': 'Продолжить с Google',
  'auth.social.apple': 'Продолжить с Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3 дня бесплатного доступа',
  'pricing.trial.credits': '250 кредитов',
  'pricing.trial.free': 'Бесплатно',
  'pricing.trial.duration': 'Без оплаты 3 дня',
  'pricing.trial.cta': 'Начать бесплатный период',
  'pricing.trial.feature1': '250 кредитов для знакомства с ИИ',
  'pricing.trial.feature2': 'Полный доступ на 3 дня',
  'pricing.trial.feature3': 'Без банковской карты',
  'pricing.trial.feature4': 'Отмена в любое время',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10 000 кредитов + 25-страничный отчёт Builder',
  'pricing.gold.credits': '10 000 кредитов',
  'pricing.gold.feature1': '10 000 кредитов',
  'pricing.gold.feature2': '25-страничный отчёт Builder',
  'pricing.gold.feature3': 'Все функции Starter и Pro',
  'pricing.gold.feature4': 'Анализ рынка и резюме',
  'pricing.gold.feature5': 'Возможности, риски, рекомендации',
  'pricing.gold.feature6': 'Скачать PDF',
  'pricing.gold.feature7': 'Поддержка',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15 000 кредитов + 100-страничный отчёт Builder',
  'pricing.platinum.credits': '15 000 кредитов',
  'pricing.platinum.feature1': '15 000 кредитов',
  'pricing.platinum.feature2': '100-страничный отчёт Builder',
  'pricing.platinum.feature3': 'Все функции Gold',
  'pricing.platinum.feature4': 'Режим Builder: брифинги для разработчиков',
  'pricing.platinum.feature5': 'Структурированное резюме',
  'pricing.platinum.feature6': 'Расширенный анализ рынка',
  'pricing.platinum.feature7': 'Поддержка',

  // Pricing UI
  'pricing.monthly': 'Ежемесячно',
  'pricing.yearly': 'Ежегодно',
  'pricing.savings': 'экономия',
  'pricing.billedYearly': 'Годовая оплата',

  // Hero trial CTA
  'hero.trialTitle': 'Начните бесплатный пробный период',
  'hero.creditsLabel': 'Кредиты',
  'hero.trialTagline': 'Попробуйте нашего ИИ-ассистента бесплатно 3 дня',
  'hero.trialCta': 'Зарегистрируйтесь и получите 250 кредитов',
  'hero.trialNoCard': 'Без банковской карты. Без обязательств.',

  // Admin
  'admin.dashboard.tabs.plans': 'Тарифы',

  // Credit top-up
  'dashboard.credits.topup.button': 'Пополнить кредиты',
  'dashboard.credits.topup.buttonTitle': 'Купите больше кредитов без смены тарифа',
  'dashboard.credits.topup.title': 'Пополнить кредиты',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 за кредит — смена тарифа не требуется',
  'dashboard.credits.topup.quickAmounts': 'Быстрый выбор',
  'dashboard.credits.topup.custom': 'Произвольно',
  'dashboard.credits.topup.totalLabel': 'Итого',
  'dashboard.credits.topup.creditsLabel': 'Кредиты',
  'dashboard.credits.topup.confirm': 'Купить сейчас',
  'footer.disclaimer': 'Отказ от ответственности',
  'legal.backToHome': 'На главную',
  'legal.lastUpdated': 'Последнее обновление',
  'legal.allRightsReserved': 'Все права защищены.',
  'legal.authoritativeNotice': 'Локализованная версия на вашем языке ещё недоступна. Ниже приведён англоязычный текст, имеющий юридическую силу.',
  'legal.translationNotice': 'Это перевод для удобства. Юридически обязательным является оригинал на английском языке.',
};

export default common;
